import * as React from "react";
import * as _ from "lodash";
import { LabelContainer, InputFieldMainContainer, ActionContainer, Input, InputContainer } from './styles';
import { ReactComponent as ExIcon } from 'common/images/search_ex.svg'
import { Label } from "common/baseComponents";

export interface InputFieldProps {
    value?: string
    placeholder?: string
    label?: string
    onChange?: (value: string) => void
}

const InputField = (props: InputFieldProps) => {
    return (
        <InputFieldMainContainer>
            {
                props.label &&
                <LabelContainer>
                    <Label>
                        {
                            props.label
                        }
                    </Label>
                </LabelContainer>
            }

            <InputContainer>
                <Input
                    placeholder={props.placeholder}
                    onChange={onInputChange}
                    value={props.value}
                />
            </InputContainer>
            <ActionContainer>
                <ExIcon onClick={() => props.onChange ? props.onChange("") : ""} />
            </ActionContainer>
        </InputFieldMainContainer>

    )

    function onInputChange(event) {
        if (props.onChange) {
            props.onChange(event?.target?.value ?? "")
        }
    }
}

export default InputField;